// extracted by mini-css-extract-plugin
module.exports = {"frontmatter":"PostTemplate-module--frontmatter--narvu","title":"PostTemplate-module--title--1-BbZ","date":"PostTemplate-module--date--2uyds"};